import { render, staticRenderFns } from "./Tuitree.vue?vue&type=template&id=4cfca374&"
import script from "./Tuitree.vue?vue&type=script&lang=ts&"
export * from "./Tuitree.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports